import { Box, useTheme } from '@mui/material';
import { iconForPartner } from '../../../common/utilities/iconForPartner';
import { Partner } from '../../../common/constants/partner';
import CloseIcon from '@mui/icons-material/Close';

const maxHeight = '48px';

const renderImage = (partner: Partner) => (
  <Box
    component="img"
    sx={partnerLogoStyles[partner]}
    onError={(e) => (e.currentTarget.style.display = 'none')}
    src={iconForPartner(partner)}
  />
);

const partnerLogoStyles = {
  [Partner.AirCanada]: {
    width: { xs: '100px', sm: '200px' },
    maxHeight,
  },
  [Partner.HtsAirline]: {
    width: { xs: '50px', sm: '100px' },
    maxHeight,
  },
  [Partner.Flair]: {
    width: { xs: '55px', sm: '95px' },
    maxHeight,
  },
  [Partner.AirAsia]: {
    width: { xs: '75px', sm: '151px' },
    maxHeight,
  },
  [Partner.Volaris]: {
    width: 'auto',
    maxHeight,
  },
  [Partner.VirginAustralia]: {
    width: { xs: '75px', sm: '151px' },
    maxHeight,
  },
};

const CLOSE_ICON_DIMENSIONS = { xs: '10px', sm: '20px' };

export const PartnerXHtsLogo = ({ partnerId }: { partnerId: Partner }) => {
  const theme = useTheme();
  const isExcludedPartner = [
    Partner.VirginAustralia,
    Partner.HtsAirline,
  ].includes(partnerId);

  return (
    <>
      {renderImage(partnerId)}
      {!isExcludedPartner && (
        <>
          <Box
            sx={{
              display: 'grid',
              alignContent: 'center',
            }}
          >
            <CloseIcon
              sx={{
                height: CLOSE_ICON_DIMENSIONS,
                width: CLOSE_ICON_DIMENSIONS,
                color: theme.palette.primary.contrastText,
              }}
            />
          </Box>
          {renderImage(Partner.HtsAirline)}
        </>
      )}
    </>
  );
};
